import component from './duration.component';

export default {
    selector: component.selector,
    options: component.options
};
